module.exports = __webpack_public_path__ + "static/media/community.700a7fe0.png";